
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/queue",
      function () {
        return require("private-next-pages/queue.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/queue"])
      });
    }
  